@if (profile != null) {
<div class="wrapper-login">
  <div class="header-sign-in">
    <div class="status-bar-wrapper svelte-7keokj">
      <button
        class="svelte-1b1v9si"
        [ngClass]="{ active: showProfileMenu }"
        (click)="showProfileMenu = !showProfileMenu"
      >
        <span class="wrapper svelte-1b1v9si" [title]="profile.name"
          ><span class="content svelte-1b1v9si"
            ><img
              class="account-picture-icon svelte-1b1v9si"
              [src]="profile.imageProfile"
              alt="Avatar"
            />
          </span>
          <span class="ml-2 text-weight-regular nome-ususario svelte-1b1v9si"
            >Olá,
            <span class="text-weight-semi-bold svelte-1b1v9si">{{
              profile.firstName
            }}</span></span
          >
          <i class="fas fa-caret-down svelte-1b1v9si" aria-hidden="true"></i
        ></span>
      </button>
      <section
        class="menu svelte-eeuijx"
        id="menu"
        [ngClass]="{ 'd-none': !showProfileMenu }"
      >
        <p class="account-picture svelte-eeuijx" style="text-align: center">
          <img
            class="account-picture-icon svelte-eeuijx"
            *ngIf="profile.imageProfile"
            [src]="profile.imageProfile"
            alt="Avatar"
          />
          <img
            class="account-picture-icon svelte-eeuijx"
            *ngIf="!profile.imageProfile"
            [src]="defaultImageProfile"
            alt="Avatar"
          />
        </p>
        <p class="account-name-greeting svelte-eeuijx" style="padding-top: 0px">
          Olá,
          <span id="account-name" class="account-name svelte-eeuijx">{{
            profile.name
          }}</span>
        </p>

        <section
          id="sso-status-bar-section"
          class="sso-status-bar-section svelte-135rngh"
        >
          <h1 id="title" class="svelte-135rngh">Minha conta</h1>
          <div>
            <div class="sso-status-bar-item svelte-boiwx6">
              <a
                href="https://contas.acesso.gov.br/alteracao_cadastro"
                target="_blank"
                class="svelte-boiwx6"
                ><i class="fas fa-user svelte-boiwx6" aria-hidden="true"></i>
                Dados Pessoais</a
              >
            </div>
            <div class="sso-status-bar-item svelte-boiwx6">
              <a
                role="button"
                id="logout-link"
                tabindex="0"
                class="svelte-boiwx6"
                (click)="logout()"
                ><i
                  class="fas fa-sign-out-alt svelte-boiwx6"
                  aria-hidden="true"
                ></i>
                Sair</a
              >
            </div>
          </div>
        </section>
      </section>
    </div>
  </div>
</div>
}
